export class FooterLayout {}
